"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonSettingsModal = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const OktonSettingsModal = ({ isOpen, onClose }) => {
    const { client } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const { colorMode, setColorMode } = (0, react_1.useColorMode)();
    const [theme, setTheme] = react_2.default.useState(colorMode);
    const [saving, setSaving] = react_2.default.useState(false);
    const [message, setMessage] = react_2.default.useState();
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    react_2.default.useEffect(() => {
        if (!isOpen)
            return;
        setTheme(colorMode);
        setMessage(undefined);
        if (client === null || client === void 0 ? void 0 : client.getPreferences) {
            client.getPreferences().then(preferences => {
                if (preferences.theme === 'light' || preferences.theme === 'dark')
                    setTheme(preferences.theme);
            }).catch(() => undefined);
        }
    }, [isOpen, colorMode, client]);
    async function save() {
        setSaving(true);
        setMessage(undefined);
        try {
            setColorMode(theme);
            if (client === null || client === void 0 ? void 0 : client.savePreferences)
                await client.savePreferences({ theme });
            setMessage('Configurações salvas.');
        }
        catch (err) {
            setMessage(err instanceof Error ? err.message : 'Não foi possível salvar as configurações.');
        }
        finally {
            setSaving(false);
        }
    }
    return (react_2.default.createElement(react_1.Modal, { isOpen: isOpen, onClose: onClose, size: "lg" },
        react_2.default.createElement(react_1.ModalOverlay, null),
        react_2.default.createElement(react_1.ModalContent, { bg: bg, rounded: "2xl" },
            react_2.default.createElement(react_1.ModalHeader, null, "Configura\u00E7\u00F5es da conta"),
            react_2.default.createElement(react_1.ModalCloseButton, null),
            react_2.default.createElement(react_1.ModalBody, null,
                react_2.default.createElement(react_1.FormControl, null,
                    react_2.default.createElement(react_1.FormLabel, null, "Tema da plataforma"),
                    react_2.default.createElement(react_1.Select, { value: theme, onChange: event => setTheme(event.target.value), rounded: "xl" },
                        react_2.default.createElement("option", { value: "light" }, "Claro"),
                        react_2.default.createElement("option", { value: "dark" }, "Escuro"))),
                message && react_2.default.createElement(react_1.Text, { mt: "4", fontSize: "sm" }, message)),
            react_2.default.createElement(react_1.ModalFooter, null,
                react_2.default.createElement(react_1.Button, { onClick: save, isLoading: saving }, "Salvar")))));
};
exports.OktonSettingsModal = OktonSettingsModal;
//# sourceMappingURL=index.js.map